import {Box} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import {renderTemplateVariables} from "../shared/surveyMarkdownText.util";
import {surveyQuestionLayout} from "./surveyRunnerColors";

interface Props {
    /** The section title in the guest's language: single-line markdown with variables. */
    title: string
}

/** A section's heading at the top of its page, outside any card. An h2, with the question titles below it as h3. */
function SurveyRunnerSectionHeading({title}: Props) {
    // Plain has no cards to set the questions apart, so a rule with room above it closes the heading off.
    const {plain} = surveyQuestionLayout(useTheme());

    return (
        <Box
            component={'h2'}
            sx={{
                m: 0,
                fontSize: 28,
                fontWeight: 600,
                lineHeight: 1.3,
                overflowWrap: 'anywhere',
                ...(plain ? {borderBottom: '1px solid', borderColor: 'divider', pb: {xs: 2, sm: 2.5}, mb: 1} : {}),
            }}
        >
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                components={{
                    // A title is one paragraph; keep its formatting in the heading's own line flow.
                    p: ({children, style}) => (
                        <Box component={'span'} style={style} sx={{display: 'block'}}>
                            {children}
                        </Box>
                    ),
                    a: ({href, children}) => <a href={href} target={'_blank'} rel={'noopener noreferrer'}>{children}</a>,
                }}
            >
                {renderTemplateVariables(title)}
            </ReactMarkdown>
        </Box>
    );
}

export default SurveyRunnerSectionHeading;
